import type { AttendanceSheetVM } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const studentRetrieveUnsignedAttendanceSheets = createApiThunk<AttendanceSheetVM[], void>(
  "attendanceSheets/studentRetrieveUnsignedAttendanceSheets",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.getUnsignedAttendanceSheets();
  },
);
